var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcStore(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.77051 23.0266V48.4664V49.9987H13.1267H26.0277H46.285V23.082",
    stroke: "#008258",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6321 16.7319H39.6309H37.1727H26.9702H24.512H3.45996H12.4426",
    stroke: "#008258",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1265 32.0925V49.1693V50.0001H26.0275V32.0925H13.1265Z",
    stroke: "#008258",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6646 32.0925V40.3263V40.7325H40.7951V32.0925H31.6646Z",
    stroke: "#008258",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4428 16.7691C12.5396 17.1743 12.5893 17.5894 12.5907 18.006C12.6007 19.3986 12.0614 20.7392 11.0894 21.7377C10.1174 22.7361 8.79098 23.3122 7.397 23.3413C6.81593 23.3395 6.23994 23.2332 5.69657 23.0275C4.63273 22.6691 3.70614 21.9903 3.04421 21.0845C2.38228 20.1787 2.01749 19.0903 2 17.9691C2.05494 16.7774 2.44577 15.6255 3.12746 14.646",
    stroke: "#008258",
    strokeWidth: 2.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.512 16.7686C24.6088 17.1738 24.6584 17.5889 24.6599 18.0055C24.67 19.395 24.1332 20.7328 23.1652 21.7308C22.1972 22.7288 20.8754 23.307 19.4847 23.3408C18.0754 23.3171 16.7305 22.7473 15.7339 21.7519C14.7373 20.7564 14.1669 19.4131 14.1431 18.0055C14.1413 17.5875 14.1973 17.1712 14.3095 16.7686",
    stroke: "#008258",
    strokeWidth: 2.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1175 16.7686C37.2143 17.1738 37.2639 17.5889 37.2653 18.0055C37.2802 19.3964 36.745 20.737 35.776 21.736C34.807 22.735 33.4824 23.3117 32.0901 23.3408C30.6809 23.3171 29.336 22.7473 28.3394 21.7519C27.3427 20.7564 26.7723 19.4131 26.7486 18.0055C26.7468 17.5875 26.8028 17.1712 26.9149 16.7686",
    stroke: "#008258",
    strokeWidth: 2.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8703 16.7686C49.96 17.1434 50.0035 17.5278 49.9997 17.9132C50.002 19.046 49.6458 20.1506 48.9819 21.069C48.318 21.9874 47.3804 22.6728 46.3031 23.027C45.8246 23.1766 45.3259 23.2513 44.8245 23.2485C43.4153 23.2248 42.0704 22.6551 41.0737 21.6596C40.0771 20.6641 39.5067 19.3208 39.483 17.9132C39.4811 17.4952 39.5371 17.079 39.6493 16.6763",
    stroke: "#008258",
    strokeWidth: 2.5
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M3.03516 15.0153L7.82222 2H44.6401L49.8708 16.8245",
    stroke: "#008258",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcStore);
export default __webpack_public_path__ + "static/media/ic-store.98176bc0d54f4e5e89d38e49ad012ba0.svg";
export { ForwardRef as ReactComponent };